function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#445896;}\n\t.st5{fill:#6AABE8;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st4",
  d: "M19.4,0.8H3.9C2.3,0.8,1,2.1,1,3.6v15.5C1,20.7,2.3,22,3.9,22h7.6l0-7.6h-2c-0.3,0-0.5-0.2-0.5-0.5l0-2.4 c0-0.3,0.2-0.5,0.5-0.5h2V8.7c0-2.7,1.7-4.2,4.1-4.2h2c0.3,0,0.5,0.2,0.5,0.5V7c0,0.3-0.2,0.5-0.5,0.5l-1.2,0 c-1.3,0-1.6,0.6-1.6,1.6v2h2.9c0.3,0,0.5,0.2,0.5,0.5L17.9,14c0,0.2-0.2,0.4-0.5,0.4h-2.6l0,7.6h4.5c1.6,0,2.9-1.3,2.9-2.9V3.6 C22.2,2.1,21,0.8,19.4,0.8z"
});

var SvgFacebookIcon = function SvgFacebookIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.8 22.8",
    style: {
      enableBackground: "new 0 0 22.8 22.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebookIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook-icon.b72396ce.svg";
export { ForwardRef as ReactComponent };